import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "template-slug-form" }
const _hoisted_2 = { class: "uk-form-controls" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "uk-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: "template-slug-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.slug) = $event)),
        class: "uk-input uk-form-small",
        type: "text",
        placeholder: _ctx.$t('shared.modals.template_slug.placeholder'),
        onChange: _cache[1] || (_cache[1] = ($event: any) => {
          // @ts-expect-error
          _ctx.v$.form.slug.$touch;
        })
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.form.slug]
      ]),
      _createVNode(_component_error_message, {
        errors: 
          // @ts-expect-error
          _ctx.v$.form.slug.$errors
        
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createVNode(_component_action_button, { class: "uk-margin-small-right uk-modal-close" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('shared.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_action_button, {
        "main-button": "",
        class: "uk-margin-small-right",
        allowed: _ctx.submittable,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitHandler()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('shared.submit')), 1)
        ]),
        _: 1
      }, 8, ["allowed"])
    ])
  ]))
}